module.exports = __webpack_public_path__ + "static/media/wesite_logo_top_white.90f39ec0.png";